module.exports = "https://cdn.redage.net/src/views/player/hudevo/phonenew/assets/images/auction.png";